module.exports = __webpack_public_path__ + "img/card-dog-0.d8ba40e0.png";